import _intersectionWith from 'lodash.intersectionwith';
import _differenceWith from 'lodash.differencewith';
// import _isArray from 'lodash.isarray';
import _isPlainObject from 'lodash.isplainobject';
function merge(dest, source) {
  var value = void 0,
      destValue = void 0;
  for (var i in source) {
    value = source[i];
    if (typeof value == 'undefined') continue;

    destValue = dest[i];
    if (!_isPlainObject(value)) {
      dest[i] = source[i];
      continue;
    }

    if (!_isPlainObject(destValue)) {
      dest[i] = {};
    }
    merge(dest[i], value);
  }

  return dest;
}
function compare(a, b) {
  if (a.max) {
    return a.min == b.min && a.max == b.max;
  } else {
    return a.value == b.value;
  }
}

export default {
  filter: function filter(collection, conditions) {
    return _intersectionWith(collection, conditions, compare);
  },
  notFilter: function notFilter(collection, conditions) {
    return _differenceWith(collection, conditions, compare);
  },
  isNeedCheck: function isNeedCheck(code) {
    if (!code) {
      return;
    }
    return ['systemdisk_category', 'systemdisk_size', 'instance_type_family', 'datadisk', 'datadisk_category', 'datadisk_size', 'iooptimized', 'customizeFamily', 'instance_generation', 'default_generation', 'default_bandwidth', 'vm_iz', 'vm_bandwidth', 'vm_is_flow_type', 'volume_category', 'default_instance_type', 'instance_type'].indexOf(code) === -1;
  },
  getResult: function getResult(resultValues) {
    if (!Array.isArray(resultValues)) {
      return resultValues;
    }
    if (resultValues.length && !resultValues[0]['max'] && !_isPlainObject(resultValues[0])) {
      return resultValues.map(function (result) {
        return { value: result };
      });
    }
    return resultValues;
  },
  getNoramlOptioinValues: function getNoramlOptioinValues(collection, constraints) {
    var _this = this;

    constraints.forEach(function (item) {
      if (item instanceof Array == false && item instanceof Object == true) {
        if (item.semantics == 'NOT') {
          collection = _this.notFilter(collection, item.value || item.values);
        } else {
          collection = _this.filter(collection, item.value || item.values);
        }
      } else {
        collection = _this.filter(collection, item, 'value');
      }
    });
    return collection;
  },
  getRangeConfig: function getRangeConfig(config, constraints, isIntersection) {
    if (config == undefined) {
      config = {};
    }
    if (config instanceof Array) {
      config = config[0];
    }
    if (constraints && constraints.length > 0) {
      var max = void 0;
      var min = void 0;
      constraints.forEach(function (item) {
        if (item && item.values && item.values[0]) {
          merge(config, item.values[0]);
        } else if (Array.isArray(item)) {
          merge(config, item[0]);
        } else {
          merge(config, item);
        }
        if (config.max != undefined && isIntersection) {
          if (max == undefined) {
            max = config.max;
          }
          max = Math.min(config.max, max);
          config.max = max;
        }
        if (config.min != undefined && isIntersection) {
          if (min == undefined) {
            min = config.min;
          }
          min = Math.max(config.min, min);
          config.min = min;
        }
      });
    }
    return config;
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ali/common-cpq-constraint/es/commonbuy/constraintHelper.js
// module id = 163
// module chunks = 0